import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RootPage = () => {
  const firebaseStore = useSelector((state) => state.firebase);
  const { auth } = firebaseStore;

  return (
    <>
      {auth.isEmpty ? (
        <Redirect to={{ pathname: '/sign-in' }} />
      ) : (
        <Redirect to={{ pathname: '/dashboard' }} />
      )}
    </>
  );
};

export default RootPage;
